module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.33f727c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.woff2
// module id = QSS9
// module chunks = 0